import React from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';

import Table from '@components/Common/Table';

import { titleStyle } from '@styles/common';
import { palette } from '@styles/theme';

import { PORTFOLIO_DETAIL_STOCKHOLDER_LIST_HEADER } from '@constants/tableheader';

/** 포트폴리오 상세 > 주주현황 > 목록 */
const StockholderListSkeleton = () => {
  const tableData = Array.from({ length: 10 })?.map((_: any, i: number) => ({
    id: i,
    no: (
      <div css={items}>
        <Skeleton variant="text" width={50} />
      </div>
    ),
    name: (
      <div css={items}>
        <Skeleton variant="text" width={80} />
      </div>
    ),
    shareholding: (
      <div css={items}>
        <Skeleton variant="text" width={120} />
      </div>
    ),
    shareholdingRatio: (
      <div css={items}>
        <Skeleton variant="text" width={80} />
      </div>
    ),
    stockType: (
      <div css={items}>
        <Skeleton variant="text" width={80} />
      </div>
    ),
  }));

  return (
    <>
      <div css={[titleStyle, { gap: '15px' }]}>
        <Skeleton variant="text" width={70} />
        <div css={divider} />
        <div css={date}>
          <Skeleton variant="text" width={160} />
        </div>
      </div>

      <div css={counts}>
        <div>
          <Skeleton variant="text" width={40} />
        </div>
        <div css={buttonWrap}>
          <Skeleton
            variant="rectangular"
            width={118}
            height={36}
            sx={{ borderRadius: '5px' }}
          />
          <Skeleton
            variant="rectangular"
            width={117}
            height={36}
            sx={{ borderRadius: '5px' }}
          />
        </div>
      </div>

      <Table
        header={PORTFOLIO_DETAIL_STOCKHOLDER_LIST_HEADER}
        data={tableData}
      />
    </>
  );
};

export default StockholderListSkeleton;

const divider = css`
  width: 2px;
  height: 18px;
  background-color: #d9d9d9;
`;

const date = css`
  color: ${palette.gray5};
  font-weight: 500;
`;

const counts = css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 10px;
  span {
    font-weight: 700;
  }
`;

const buttonWrap = css`
  display: flex;
  gap: 10px;
`;

const items = css`
  display: flex;
  justify-content: center;
`;
